import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { TiposUnidadDTO } from "src/app/models/tipo-unidad.dto";
import { Permiso, Section } from "../form/form.component";
import { PasswordModal } from "../pass-modal/pass-modal.component";

@Component({
  selector: "app-form-drawer-tipo-unidad",
  templateUrl: "./drawer-form.component.html",
})
export class UsersDrawerForm
  extends CrudForm<TiposUnidadDTO>
  implements OnInit
{
  modulos: Section[] = [
    {
      name: "Admin",
      desc: "Modulos de admin",
      options: [
        { id: "admin_dash", desc: "Dashboard" },
        { id: "admin_alerts", desc: "Alertas" },
        { id: "admin_reportes", desc: "Reportes" },
      ],
    },
    {
      name: "Oficina",
      desc: "Modulos de oficina",
      options: [
        { id: "office_caja", desc: "Caja" },
        { id: "office_actas", desc: "Actas administrativas" },
        { id: "office_cartas", desc: "Cartas Compromiso" },
      ],
    },
    {
      name: "Unidades",
      desc: "Modulos de Unidades",
      options: [
        { id: "unit_lista", desc: "Listado" },
        { id: "unit_asignacion", desc: "Asignacion" },
        { id: "unit_entrega", desc: "Entrega a chofer" },
        { id: "unit_recibir", desc: "Recibir en taller" },
        { id: "unit_percances", desc: "Revision de percances" },
        { id: "unit_historial", desc: "Historial" },
      ],
    },
    {
      name: "Inventario",
      desc: "Modulos de Inventario",
      options: [
        { id: "warehouse_moves", desc: "Movimientos" },
        { id: "warehouse_inventario", desc: "Inventario" },
        { id: "warehouse_materials", desc: "Materiales" },
      ],
    },
    {
      name: "Taller",
      desc: "Modulos de Taller",
      options: [
        { id: "taller_programar", desc: "Programar" },
        { id: "taller_mant", desc: "Mantenimientos" },
        { id: "taller_campana", desc: "Campañas" },
        { id: "taller_historial", desc: "Historial" },
      ],
    },
    {
      name: "Trabajadores",
      desc: "Modulos de Trabajadores",
      options: [
        { id: "worker_index", desc: "Trabajadores" },
        { id: "worker_credenciales", desc: "Credenciales" },
        { id: "worker_banned", desc: "No recomendados" },
      ],
    },
    {
      name: "Catalogos",
      desc: "Modulos de Catalogos",
      options: [
        { id: "cats_tpmat", desc: "Tipo de materiales" },
        { id: "cats_tpserv", desc: "Tipo de servicios" },
        { id: "cats_tpunidad", desc: "Tipo de unidad" },
        { id: "cats_empresas", desc: "Empresas" },
        { id: "cats_plantas", desc: "Plantas" },
        { id: "cats_proveedores", desc: "Proveedores" },
        { id: "cats_funcion", desc: "Funcionamiento" },
        { id: "cats_usuarios", desc: "Usuarios" },
      ],
    },
  ];

  especiales: Section[] = [
    {
      name: "Trabajadores",
      desc: "Permisos especiales de Trabajadores",
      options: [
        {
          id: "spcl_worker_reingreso",
          desc: "Reingresar trabajadores en la lista NO REINGRESO",
        },
      ],
    },
    // {
    //   name: "Actas",
    //   desc: "Permisos especiales de Actas",
    //   options: [
    //     { id: "spcl_act_edit", desc: "Editar acta administrativa" },
    //     { id: "spcl_act_remove", desc: "Eliminar acta administrativa" },
    //   ],
    // },
    {
      name: "Recepcion/Entrega",
      desc: "Permisos especiales de Recepcion/Entrega",
      options: [
        { id: "spcl_recp_edit", desc: "Editar Recepcion/Entrega" },
        { id: "spcl_recp_remove", desc: "Eliminar Recepcion/Entrega" },
      ],
    },
    {
      name: "Usuarios",
      desc: "Permisos especiales de usuarios",
      options: [
        { id: "spcl_user_pass", desc: "Cambiar contrasenas de usuarios" },
      ],
    },
  ];

  dashWidgets: Permiso[] = [
    { id: "widget_resumen", desc: "Resumen de unidades" },
    { id: "widget_deudores", desc: "Tabla: Trabajadores con deudas" },
    { id: "widget_rojos", desc: "Tabla: Materiales debajo del minimo" },
  ];

  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: TiposUnidadDTO;
  };
  constructor(public fb: FormBuilder) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
  public fromInit(row: any) {
    this.form.controls["IdUsuario"].setValue(row?.IdUsuario);
    this.form.controls["Usuario"].patchValue(row?.Usuario);
    this.form.controls["Contrasena"].patchValue(row?.Contrasena);
    this.form.controls["Correo"].patchValue(row?.Correo);
    this.form.controls["Iniciales"].patchValue(row?.Iniciales);
    this.form.controls["Color"].patchValue("#000000");
  }
  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;

    const flatModulos = this.modulos
      .map((m) => m.options)
      .flat()
      .map((m) => m.id);

    const flatEspeciales = this.especiales
      .map((m) => m.options)
      .flat()
      .map((m) => m.id);

    const flatDash = this.dashWidgets.flat().map((m) => m.id);

    this.form.controls["IdUsuario"].setValue(row?.IdUsuario);
    this.form.controls["Usuario"].patchValue(row?.Usuario);
    this.form.controls["Correo"].patchValue(row?.Correo);
    this.form.controls["Iniciales"].patchValue(row?.Iniciales);
    this.form.controls["Color"].patchValue(row?.Color);
    this.form.controls["permisosSelected"].patchValue(
      row?.Permisos.filter((f) => flatModulos.includes(f))
    );
    this.form.controls["specialSelected"].patchValue(
      row?.Permisos.filter((f) => flatEspeciales.includes(f))
    );
    this.form.controls["widgetsSelected"].patchValue(
      row?.Permisos.filter((f) => flatDash.includes(f))
    );
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdUsuario: [],
      Usuario: [""],
      Contrasena: [""],
      Correo: [""],
      permisosSelected: [],
      specialSelected: [],
      widgetsSelected: [],
      Iniciales: [""],
      Color: ["#000000"],
    });
  }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }

  public openTab = 1;
  toggleTabs($tabNumber: number) {
    this.openTab = $tabNumber;
  }
}
